<template>
    <div
        class="mt-4 btn tertiary btn-misc px-4"
        @click="
            $modal.show('read-terms-modal', {
                data: {},
            })
        "
    >
        <span class="mr-2">Terms &amp; Conditions</span
        ><i class="far fa-info"></i>
    </div>
</template>

<script>
export default {
    props: [],
};
</script>

<style></style>
